"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function state(s) {
    const { errorMessage, isAuthenticated, isProcessing } = s.session;
    return { errorMessage, isAuthenticated, isProcessing };
}
exports.state = state;
//# sourceMappingURL=selectors.js.map